import React, { useEffect } from 'react';
import { Button, Card, Form, Grid, Input, Label, Modal, Segment, Select, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import './SelectListingModal.scss';
import * as _ from 'lodash';
import { Formik } from 'formik';

/**
 * Searches all listings for users to select
 */
const SelectHomeOfTheWeekListingsModal = ({
  slots,
  listings,
  getListings,
  handleSelection,
  firms,
  getFirms,
  setQuery,
  paginate,
  setActivePage,
}) => {
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState([]);
  const [selectedDict, setSelectedDict] = React.useState({});

  useEffect(() => {
    getFirms();
    getListings();
    // getReps();
    // preloadShowcaseData();
  }, []);

  const handleSubmit = () => {
    handleSelection(selected);
    setOpen(false);
  };

  useEffect(() => getListings(), []);

  useEffect(() => {
    setSelected([...slots]);
  }, [slots]);

  useEffect(() => {
    const temp = {};
    selected.forEach(id => (temp[id] = true));
    setSelectedDict({ ...temp });
  }, [selected]);

  const handleSelect = listing => {
    if (selectedDict[listing.id]) {
      let temp = _.remove(selected, item => item !== listing.id);
      temp = _.uniq(temp);
      setSelected(temp);
    } else {
      setSelected([...selected, listing.id]);
    }
  };

  const getPage = () => (
    <Modal
      size="fullscreen"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <div>
          <Button size="small" icon="search" labelPosition="left" content="Select Listings" floated="right" />
        </div>
      }
    >
      <Modal.Header>Select listings</Modal.Header>

      <Modal.Content className="select-listing-modal" scrolling>
        <Grid reversed="mobile">
          <Grid.Column computer="13" table="10" mobile="16">
            <Table selectable compact="very" size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Firm</Table.HeaderCell>
                  <Table.HeaderCell>Address</Table.HeaderCell>
                  <Table.HeaderCell>Description 1</Table.HeaderCell>
                  <Table.HeaderCell>Description 2</Table.HeaderCell>
                  <Table.HeaderCell>Type</Table.HeaderCell>
                  <Table.HeaderCell>City</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {listings.map((listing, idx) => (
                  <Table.Row key={idx} onClick={() => handleSelect(listing)} label={{}}>
                    <Table.Cell>
                      {selectedDict[listing?.id] && <Label size="tiny" empty color="green" ribbon />}
                      {listing.firm.name}
                    </Table.Cell>
                    <Table.Cell>{listing.address}</Table.Cell>
                    <Table.Cell>{listing.description1}</Table.Cell>
                    <Table.Cell>{listing.description2}</Table.Cell>
                    <Table.Cell>{listing.type}</Table.Cell>
                    <Table.Cell>{listing.city}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            <Segment basic style={{ display: 'grid', justifyContent: 'center' }}>
              {/* <Pagination
                onPageChange={(e, { activePage }) => paginate(activePage)}
                activePage={activePage || 1}
                totalPages={pages}
              /> */}
            </Segment>
          </Grid.Column>
          <Grid.Column computer="3" tablet="6" mobile="16">
            <Formik
              enableReinitialize
              initialValues={{ showcaseFirmId: '', description1: '', description2: '', address: '', type: '' }}
              onSubmit={values => {
                setQuery({ ...values, page: 1 });
                getListings();
              }}
            >
              {formik => (
                <Form size="small" onSubmit={formik.handleSubmit}>
                  <Card fluid>
                    <Card.Content>
                      <Form.Field>
                        <label>Firm</label>
                        <Select
                          options={firms}
                          value={formik.values.showcaseFirmId}
                          search
                          fluid
                          size="small"
                          // loading={loading}
                          onChange={(e, { value }) => formik.setFieldValue('showcaseFirmId', value)}
                          placeholder="Search firms"
                          name="showcaseFirmId"
                          id="showcaseFirmId"
                          label="Firm"
                          clearable
                        />
                      </Form.Field>

                      <Form.Field>
                        <label>Type</label>
                        <Select
                          options={['Product', 'Property', 'Property w/o Realtor'].map(k => ({
                            key: k,
                            value: k,
                            text: k,
                          }))}
                          value={formik.values.type}
                          search
                          fluid
                          size="small"
                          // loading={loading}
                          onChange={(e, { value }) => formik.setFieldValue('type', value)}
                          placeholder="Search types"
                          name="type"
                          id="type"
                          label="Type"
                          clearable
                        />
                      </Form.Field>

                      <Form.Field>
                        <label>Description 1</label>
                        <Input
                          fluid
                          size="small"
                          value={formik.values.description1}
                          onChange={formik.handleChange}
                          name="description1"
                          id="description1"
                        />
                      </Form.Field>

                      <Form.Field>
                        <label>Address</label>
                        <Input
                          fluid
                          size="small"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          name="address"
                          id="address"
                        />
                      </Form.Field>

                      <br />

                      <Button fluid type="submit" positive>
                        Search
                      </Button>

                      <br />

                      <Button
                        type="button"
                        fluid
                        content="Clear"
                        onClick={() => {
                          formik.resetForm();
                          formik.handleSubmit();
                        }}
                      />
                    </Card.Content>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid.Column>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button content="Add Selected Listings to Email" onClick={handleSubmit} positive />
      </Modal.Actions>
    </Modal>
  );

  return <>{listings && getPage()}</>;
};

const mapStateToProps = state => ({
  firms: selectors.firms.options(state),
  listings: selectors.getListings(state),
});

const mapDispatchToProps = dispatch => ({
  getListings: bindActionCreators(actions.listing.getListings, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
  paginate: bindActionCreators(actions.listing.paginate, dispatch),
  setActivePage: bindActionCreators(actions.listing.setActivePage, dispatch),
  setQuery: bindActionCreators(actions.listing.setQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectHomeOfTheWeekListingsModal);
